'use strict';

class megaMenu {
  constructor() {
    this.activeClass = 'mega-menu--is-open'
    this.megaMenu = document.querySelector('.mega-menu')
    this.megaMenuParent = this.megaMenu.querySelectorAll('.mega-menu--parent')
    this.container = this.megaMenu.querySelectorAll('.mega-menu__container')
    this.containerInitialWidth = 250
    this.desktopContainer = this.megaMenu.querySelectorAll('.mega-menu__container--desktop')
    this.borderWidth = 1
    this.init()
  }

  mouseOverChildren(item, innerItemLevel1, container) {
    // Prevent adding events to one-column class
    if (!item.classList.contains('mega-menu--one-column')) {
      innerItemLevel1.forEach(innerItem => {
        const innerListLevel2 = innerItem.querySelector('.mega-menu__inner-list--level2'),
              innerProduct    = innerItem.querySelector('.mega-menu--product')

        if (innerListLevel2 !== null) {
          // Open menu elements with opened class
          if (innerItem.classList.contains('mega-menu--opened')) {
            this.mouseInElement(innerListLevel2, container, innerProduct)
            window.onresize = () => {
              this.mouseInElement(innerListLevel2, container, innerProduct)
            }
          }
          else {
            // Add events to all inner-item--level1 class
            innerItem.addEventListener('mouseover', () => {
              this.mouseInElement(innerListLevel2, container, innerProduct)
              innerItem.focus()
            })
            innerItem.addEventListener('mouseout', () => {
              this.mouseOutElement(innerListLevel2, container)
              innerItem.focus()
            })
          }
        }
      })
    }
  }

  mouseInElement(innerList, container, product) {
    // make innerList visible
    innerList.style.display = 'grid'
    innerList.setAttribute('aria-hidden', 'false')

    // set level2 width (fix for firefox browser)
    const columns = innerList.querySelector('.mega-menu__inner-list--level2-columns')
    const columsWidth = columns.offsetWidth

    if (columsWidth > 0) {
      innerList.style.width = columsWidth + this.borderWidth + 'px'
    }

    // set container width
    const innerListWidth = innerList.offsetWidth;
    const productWidth = product?.offsetWidth || 0;
    container.style.width = `${this.containerInitialWidth + innerListWidth + productWidth}px`

    // product absolute position
    if (product !== null) {
      product.style.left = `${innerList.offsetWidth}px`
    }
  }

  mouseOutElement(innerList, container) {
    // make innerList hidden
    innerList.style.display = 'none'
    innerList.setAttribute('aria-hidden', 'true')
    // reset widths
    container.style.width = `${this.containerInitialWidth}px`
    innerList.style.width = 'auto'
  }

  isActive(item) {
    return item.classList.contains(this.activeClass)
  }

  show(item) {
    item.classList.add(this.activeClass)
  }

  hide(item) {
    item.classList.remove(this.activeClass)
  }

  toggle(item) {
    if (this.isActive(item)) {
      this.hide(item)
    }
    else {
      this.hideOtherItems()
      this.show(item)
    }
  }

  hideOtherItems() {
    this.megaMenuParent.forEach(item => {
      this.hide(item)
    })
  }

  hasTrigger(arr, target) {
    let containsTarget = false;
    arr.forEach(item => {
      if (item.contains(target)) {
        containsTarget = true;
      }
    })
    return containsTarget;
  }

  clickOverParent(link, item) {
    link.addEventListener('click', () => {
      this.toggle(item)
    })
  }

  closeOnClickOutside(e) {
    this.container.forEach((item, index) => {
      const link = this.megaMenuParent[index]
      if (
        (!item.contains(e.target)) &&
        (!this.hasTrigger(this.megaMenuParent, e.target))
      ) {
        if (this.isActive(link)) {
          this.hide(link)
        }
      }
    })
  }

  setHoverEvents() {
    document.addEventListener('click', e => {
      this.closeOnClickOutside(e)
    })
    this.megaMenuParent.forEach(item => {
      const innerItemLevel1 = item.querySelectorAll('.mega-menu__inner-item--level1'),
            container       = item.querySelector('.mega-menu__container'),
            link            = item.querySelector('.mega-menu__link')

      if (innerItemLevel1 && container) {
        this.mouseOverChildren(item, innerItemLevel1, container)
      }

      if (link) {
        this.clickOverParent(link, item)
      }
    })
  }


  init() {
    this.setHoverEvents()
  }
}

new megaMenu()
